import React from "react";
import { CustomIconButton, createNotification, icon } from "../../../../../../common/components";
import { translate } from "../../../../../../common/providers";
import { useApi } from "../../../../../../common/hooks";
import { AiAgentsService } from "../../../../../../api";
import { downloadFile } from "../../../../../../common/utils";
import { formatTokenPrice, mapAgentModelError, resolveExportFilename, translateEnumProvider } from "../../utils";
import styles from "./AiModelRow.module.css";

export default function AiModelRow({
	model,
	onDelete,
	onEdit,
	visibleColumns,
	columnWidths,
	minColumnWidth,
	isDev,
	actionsWidth,
}) {
	const { call: exportModelById, isLoading: isExporting } = useApi(AiAgentsService.exportModelById);

	const handleExport = () => {
		exportModelById({ modelId: model.id })
			.then(({ data, filename }) => {
				downloadFile({
					data,
					filename: resolveExportFilename(filename, "model_export.json"),
					filetype: "json",
				});
			})
			.catch((error) => {
				createNotification({
					type: "error",
					message: mapAgentModelError(error) || translate("dsi.agents.ai-models.export.failure"),
				});
			});
	};

	const cells = {
		name: model.name,
		description: model.description || "—",
		provider: translateEnumProvider(model.providerType),
		deployment: model.deploymentName || model.deployment || model.location || "—",
		model: model.modelName || "—",
		inputCost: formatTokenPrice(model.inputCostPerMillion),
		outputCost: formatTokenPrice(model.outputCostPerMillion),
		status: model.active
			? translate("dsi.agents.models.status.active")
			: translate("dsi.agents.models.status.inactive"),
	};

	return (
		<div className={styles.row}>
			{visibleColumns.map((columnKey) => {
				const width = columnWidths[columnKey] || minColumnWidth;
				return (
					<div
						key={columnKey}
						className={styles.cell}
						style={{ flex: `0 0 ${width}px`, width: `${width}px` }}
					>
						{cells[columnKey]}
					</div>
				);
			})}
			<div className={styles.actions} style={{ flex: `0 0 ${actionsWidth}px` }}>
				{isDev && (
					<CustomIconButton
						disabled={isExporting}
						icon={icon.faFileExport}
						size="sm"
						tooltip={translate("dsi.agents.ai-models.export.row-button")}
						variant="outlined"
						onClick={handleExport}
					/>
				)}
				<CustomIconButton
					icon={icon.faPenToSquare}
					size="sm"
					tooltip={translate("common:btn.edit")}
					variant="outlined"
					onClick={() => onEdit(model)}
				/>
				<CustomIconButton
					icon={icon.faTrash}
					size="sm"
					tooltip={translate("common:btn.delete")}
					variant="outlined"
					onClick={() => onDelete(model)}
				/>
			</div>
		</div>
	);
}
